// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"C1-z"};